import { TYPE_IS_SIGNATORY } from './constants';

const isSignatory = (participant) => (
  participant.type === TYPE_IS_SIGNATORY
);

export default isSignatory;
